/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'medal': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M24.5 4.83a11.56 11.56 0 0 0-11.63 11.5c0 6.35 5.21 11.5 11.63 11.5 6.42 0 11.63-5.15 11.63-11.5S30.91 4.83 24.5 4.83zM9 16.33C9 7.86 15.94 1 24.5 1 33.06 1 40 7.86 40 16.33c0 8.47-6.94 15.34-15.5 15.34C15.94 31.67 9 24.8 9 16.33z"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M31.59 25.7c1.06-.14 2.03.6 2.17 1.65l2.35 17.48a1.9 1.9 0 0 1-.86 1.86c-.62.4-1.42.42-2.06.04l-8.69-5.16-8.7 5.16c-.63.38-1.43.36-2.05-.04a1.9 1.9 0 0 1-.86-1.86l2.35-17.46a1.93 1.93 0 0 1 2.17-1.65c1.06.14 1.8 1.1 1.67 2.15L17.26 41.4l6.24-3.7a1.96 1.96 0 0 1 2 0l6.24 3.7-1.82-13.53a1.92 1.92 0 0 1 1.67-2.16z"/>'
  }
})
